/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PatientHoldingViewModel } from './patientHoldingViewModel';
import { InsuranceHoldingViewModel } from './insuranceHoldingViewModel';
import { PatientViewModel } from './patientViewModel';
import { InsuranceDetailsViewModel } from './insuranceDetailsViewModel';
import { ProcedureTransactionHoldingDetailsViewModel } from './procedureTransactionHoldingDetailsViewModel';
import { ProcedureResultHoldingViewModel } from './procedureResultHoldingViewModel';

export interface VisitHoldingViewModel {
  procedureTransactionHoldings?: Array<ProcedureTransactionHoldingDetailsViewModel> | null;
  id?: string;
  datasetId?: string;
  sendingFacilityId?: string;
  patientId?: string | null;
  patientHoldingId?: string | null;
  accidentTypeId?: string | null;
  primaryInsuranceHoldingId?: string | null;
  secondaryInsuranceHoldingId?: string | null;
  tertiaryInsuranceHoldingId?: string | null;
  primaryInsuranceId?: string | null;
  secondaryInsuranceId?: string | null;
  tertiaryInsuranceId?: string | null;
  accidentStateCode?: string | null;
  referenceNumber?: number;
  financialClassId?: string | null;
  financialClassLinkId?: string | null;
  attendingProviderId?: string | null;
  attendingProviderLinkId?: string | null;
  referringProviderId?: string | null;
  referringProviderLinkId?: string | null;
  supervisingProviderId?: string | null;
  locationId?: string | null;
  locationLinkId?: string | null;
  hospitalAdmitDate?: string | null;
  hospitalDischargeDate?: string | null;
  illnessInjuryDate?: string | null;
  patientStatus?: string | null;
  externalId?: string | null;
  visitDate?: string | null;
  holdVisit?: boolean;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  primaryInsuranceAuthNumber?: string | null;
  secondaryInsuranceAuthNumber?: string | null;
  tertiaryInsuranceAuthNumber?: string | null;
  referringProviderRequired?: boolean;
  hasDemographicUpdates?: boolean;
  pwkReportTypeCode?: string | null;
  pwkTransmissionCode?: string | null;
  pwkAttachmentNumber?: string | null;
  pointOfOriginId?: string | null;
  admissionTypeId?: string | null;
  dischargeStatusId?: string | null;
  admitHour?: number | null;
  dischargeHour?: number | null;
  billingNote?: string | null;
  claimNoteType1?: string | null;
  claimNote1?: string | null;
  claimNoteType2?: string | null;
  claimNote2?: string | null;
  claimNoteType3?: string | null;
  claimNote3?: string | null;
  claimNoteType4?: string | null;
  claimNote4?: string | null;
  claimNoteType5?: string | null;
  claimNote5?: string | null;
  claimNoteType6?: string | null;
  claimNote6?: string | null;
  claimNoteType7?: string | null;
  claimNote7?: string | null;
  claimNoteType8?: string | null;
  claimNote8?: string | null;
  claimNoteType9?: string | null;
  claimNote9?: string | null;
  claimNoteType10?: string | null;
  claimNote10?: string | null;
  admittingDiagnosisCodeId?: string | null;
  admittingDiagPresentOnAdmission?: string | null;
  visitReason1DiagnosisCodeId?: string | null;
  visitReason1PresentOnAdmission?: string | null;
  visitReason2DiagnosisCodeId?: string | null;
  visitReason2PresentOnAdmission?: string | null;
  visitReason3DiagnosisCodeId?: string | null;
  visitReason3PresentOnAdmission?: string | null;
  cause1DiagnosisCodeId?: string | null;
  cause1PresentOnAdmission?: string | null;
  cause2DiagnosisCodeId?: string | null;
  cause2PresentOnAdmission?: string | null;
  cause3DiagnosisCodeId?: string | null;
  cause3PresentOnAdmission?: string | null;
  drgDiagnosisCodeId?: string | null;
  drgPresentOnAdmission?: string | null;
  principalProcedureId?: string | null;
  principalProcedureDate?: string | null;
  otherProcedure1Id?: string | null;
  otherProcedure1Date?: string | null;
  otherProcedure2Id?: string | null;
  otherProcedure2Date?: string | null;
  otherProcedure3Id?: string | null;
  otherProcedure3Date?: string | null;
  otherProcedure4Id?: string | null;
  otherProcedure4Date?: string | null;
  otherProcedure5Id?: string | null;
  otherProcedure5Date?: string | null;
  occurrenceSpanCode1Id?: string | null;
  occurrenceSpan1FromDate?: string | null;
  occurrenceSpan1ToDate?: string | null;
  occurrenceSpanCode2Id?: string | null;
  occurrenceSpan2FromDate?: string | null;
  occurrenceSpan2ToDate?: string | null;
  occurrenceCode1Id?: string | null;
  occurrence1Date?: string | null;
  occurrenceCode2Id?: string | null;
  occurrence2Date?: string | null;
  occurrenceCode3Id?: string | null;
  occurrence3Date?: string | null;
  occurrenceCode4Id?: string | null;
  occurrence4Date?: string | null;
  valueCode1Id?: string | null;
  value1Amount?: number | null;
  valueCode2Id?: string | null;
  value2Amount?: number | null;
  valueCode3Id?: string | null;
  value3Amount?: number | null;
  conditionCode1Id?: string | null;
  conditionCode2Id?: string | null;
  conditionCode3Id?: string | null;
  conditionCode4Id?: string | null;
  conditionCode5Id?: string | null;
  conditionCode6Id?: string | null;
  conditionCode7Id?: string | null;
  conditionCode8Id?: string | null;
  conditionCode9Id?: string | null;
  conditionCode10Id?: string | null;
  conditionCode11Id?: string | null;
  visitAttendingProviderId?: string | null;
  visitReferringProviderId?: string | null;
  visitSupervisingProviderId?: string | null;
  diagnosis1Id?: string | null;
  diagnosis1PresentOnAdmission?: string | null;
  diagnosis2Id?: string | null;
  diagnosis2PresentOnAdmission?: string | null;
  diagnosis3Id?: string | null;
  diagnosis3PresentOnAdmission?: string | null;
  diagnosis4Id?: string | null;
  diagnosis4PresentOnAdmission?: string | null;
  diagnosis5Id?: string | null;
  diagnosis5PresentOnAdmission?: string | null;
  diagnosis6Id?: string | null;
  diagnosis6PresentOnAdmission?: string | null;
  diagnosis7Id?: string | null;
  diagnosis7PresentOnAdmission?: string | null;
  diagnosis8Id?: string | null;
  diagnosis8PresentOnAdmission?: string | null;
  diagnosis9Id?: string | null;
  diagnosis9PresentOnAdmission?: string | null;
  diagnosis10Id?: string | null;
  diagnosis10PresentOnAdmission?: string | null;
  diagnosis11Id?: string | null;
  diagnosis11PresentOnAdmission?: string | null;
  diagnosis12Id?: string | null;
  diagnosis12PresentOnAdmission?: string | null;
  diagnosis1LinkId?: string | null;
  diagnosis2LinkId?: string | null;
  diagnosis3LinkId?: string | null;
  diagnosis4LinkId?: string | null;
  diagnosis5LinkId?: string | null;
  diagnosis6LinkId?: string | null;
  diagnosis7LinkId?: string | null;
  diagnosis8LinkId?: string | null;
  diagnosis9LinkId?: string | null;
  diagnosis10LinkId?: string | null;
  diagnosis11LinkId?: string | null;
  diagnosis12LinkId?: string | null;
  estimatedPatientBalance?: number | null;
  initialClaimType?: string | null;
  patientOutput?: string | null;
  financialClassOutput?: string | null;
  patient?: PatientViewModel;
  patientHolding?: PatientHoldingViewModel;
  primaryInsuranceHolding?: InsuranceHoldingViewModel;
  secondaryInsuranceHolding?: InsuranceHoldingViewModel;
  tertiaryInsuranceHolding?: InsuranceHoldingViewModel;
  primaryInsurance?: InsuranceDetailsViewModel;
  secondaryInsurance?: InsuranceDetailsViewModel;
  tertiaryInsurance?: InsuranceDetailsViewModel;
  procedureResultHoldings?: Array<ProcedureResultHoldingViewModel> | null;
}
